import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-[#FFF8F0] py-20 px-6" data-id="element-158">
      <div className="max-w-4xl mx-auto" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-[#5C4B3A]/10 relative overflow-hidden" data-id="element-160">
          {/* Decorative background shape */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#E76F51]/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-161"></div>

          <div className="relative z-10 space-y-6 text-[#5C4B3A] text-lg leading-relaxed" data-id="element-162">
            <p data-id="element-163">
              El "pánico del domingo" y las mañanas caóticas no ocurren por
              falta de amor, sino por{' '}
              <strong className="text-[#E76F51]" data-id="element-164">
                falta de un método adaptado a tu realidad
              </strong>
              .
            </p>
            <p data-id="element-165">
              Las recetas que ves en Pinterest piden ingredientes que no
              encuentras en el D1 o el Ara, y los tutoriales con reels o fotos
              perfectas de Instagram que requieren dos horas que simplemente no
              tienes.
            </p>
            <div className="bg-[#FFF8F0] p-6 rounded-2xl border-l-4 border-[#2D6A4F] mt-8" data-id="element-166">
              <p className="italic text-[#2D6A4F] font-medium" data-id="element-167">
                El resultado es siempre el mismo: terminas enviando lo que sea
                por afán, tu hijo devuelve la lonchera intacta porque "está
                fría" o "sabe feo", y tú empiezas tu jornada laboral sintiéndote
                derrotada.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}